import { Box, Button, Dialog, DialogActions, DialogContent, useMediaQuery, useTheme, } from "@mui/material";
import { ModalSheet } from "./modal-sheet.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const Modal = ({ actions, children, label, dialogProps = {}, sx = {}, ...props }) => {
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const useDialog = useMediaQuery(theme.breakpoints.up("sm"));
    const defaultActions = (React.createElement(Button, { color: "inherit", variant: useDialog ? "text" : "contained", fullWidth: !useDialog, onClick: props.onClose }, t("button-close", "Schließen")));
    return useDialog ? (React.createElement(Dialog, { "aria-label": label, open: props.open, onClose: props.onClose, ...dialogProps },
        React.createElement(DialogContent, { "data-testid": "modal-dialog-content", color: "secondary", sx: { px: 6, py: 6, ...sx } }, children),
        actions !== false && React.createElement(DialogActions, null, actions ?? defaultActions))) : (React.createElement(ModalSheet, { label: label, sx: { color: theme.palette.primary.dark, ...sx }, ...props },
        children,
        actions !== false && React.createElement(Box, { sx: { mt: 3 } }, actions ?? defaultActions)));
};
//# sourceMappingURL=modal.js.map